export const BRAND_NAME = 'INGENIUM SOFT';
export const BRAND_SHORT = 'INGENIUM';
export const BRAND_TAGLINE = 'SOFT';
export const BRAND_PRODUCT = 'INGENIUM SOFT';
export const ALLIANCE_NAME = 'Ingenium Alliance';
export const LEGAL_NAME = 'INGENIUM ALLIANCE S.A.C.';
export const RUC = '20611356472';
export const ALLIANCE_PRESENTS = `El grupo ${ALLIANCE_NAME} presenta`;
export const ALLIANCE_PRESENTS_UPPER = 'EL GRUPO INGENIUM ALLIANCE PRESENTA';
